var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"flex items-center justify-center appearance-none cursor-pointer lg:hover:opacity-50",class:[_vm.bg, _vm.color, _vm.px, _vm.py, _vm.textSize, _vm.fontWeight, _vm.border],attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }